const initialState = [
  // upcoming:
  // {
  //   amount_due: 800,
  //   billing_reason: "upcoming",
  //   next_payment_attempt: "Friday, Aug  3, 2018",
  //   billing: "send_invoice",
  //   date: "Monday, Sep  3, 2018",
  //   period_end: "Monday, Sep  3, 2018",
  //   period_start: "Friday, Aug  3, 2018",
  //   invoice_pdf:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU/pdf"
  // },
  //
  // // invoices:
  // {
  //   id: "in_1Cuv33BZ5FQnDawZHkySnr54",
  //   amount_due: 800,
  //   billing_reason: "subscription_update",
  //   hosted_invoice_url:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU",
  //   invoice_pdf:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU/pdf",
  //   next_payment_attempt: "Friday, Aug  3, 2018",
  //   paid: false,
  //   billing: "send_invoice",
  //   // date: "Friday, Aug  3, 2018",
  //   period_end: "Friday, Aug  3, 2018",
  //   period_start: "Friday, Aug  3, 2018"
  // },
  // {
  //   id: "in_1Cuv33BZ5FQnDawZHkySnr54",
  //   amount_due: 800,
  //   billing_reason: "subscription_update",
  //   hosted_invoice_url:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU",
  //   invoice_pdf:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU/pdf",
  //   next_payment_attempt: "Friday, Aug  3, 2018",
  //   paid: false,
  //   billing: "charge_automatically",
  //   // date: "Friday, Aug  3, 2018",
  //   period_end: "Friday, Aug  3, 2018",
  //   period_start: "Friday, Aug  3, 2018"
  // },
  // {
  //   id: "in_1Cuv33BZ5FQnDawZHkySnr54",
  //   amount_due: 800,
  //   billing_reason: "subscription_update",
  //   hosted_invoice_url:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU",
  //   invoice_pdf:
  //     "https://pay.stripe.com/invoice/invst_EDa1TFMtOd3JI5xmSvjVm6cRPU/pdf",
  //   next_payment_attempt: null,
  //   paid: true,
  //   // billing: "charge_automatically",
  //   // date: "Friday, Aug  3, 2018",
  //   period_end: "Friday, Aug  3, 2018",
  //   period_start: "Friday, Aug  3, 2018"
  // }
]

function invoices(state = initialState, action) {
  switch (action.type) {
    case "GET_INVOICES_SUCCESS":
      return [...action.data]

    case "GET_MORE_INVOICES_SUCCESS":
      return [...state, ...action.data]

    default:
      return state
  }
}

export default invoices



// WEBPACK FOOTER //
// ./src/models/invoices.js